import React from 'react';
import { Grid, Paper } from '@mui/material';
import { StyledSnackbar } from '../../../components/common/AppSnackbar';
import LastSavedIndicator from '../LastSavedIndicator';

const FormLayoutWrapper = ({
  // Layout classes
  classes,

  // Children components
  navigationComponent,
  children,

  // Alert props
  alertOpen = false,
  alertMessage,
  alertStatus,
  onAlertClose,

  // Paper props
  paperClassName,

  // Grid props
  layoutClassName,
  containerSpacing = 1,

  // Last saved props
  lastSaved,

  // Additional props for flexibility
  showAlert = true,
  mainContentGridProps = { xs: 12, md: 8 },
}) => {
  const renderAlert = () => {
    if (!showAlert || !alertOpen) return null;

    return (
      <StyledSnackbar
        open={alertOpen}
        message={alertMessage}
        severity={alertStatus || "info"}
        onClose={onAlertClose}
        autoHideDuration={6000}
      />
    );
  };

  return (
    <Grid
      container
      spacing={containerSpacing}
      className={layoutClassName || classes.layout}
    >
      {/* Navigation Menu */}
      {navigationComponent}

      {/* Main Content */}
      <Grid item {...mainContentGridProps}>
        {renderAlert()}

        <Paper
          className={paperClassName || classes.paper}
          sx={{ position: 'relative' }}
        >
          <LastSavedIndicator lastSaved={lastSaved} />
          {children}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default FormLayoutWrapper;
